import { useTranslation } from "react-i18next";
import LiiferLogoSvg from "../../assets/svg/liifer-burger-logo.svg";

export const downloadLink =
  "https://download.overwolf.com/install/Download?Name=Liifer+-+Food+Order&ExtensionId=jcedejgjifggfepoinicmboalnkldjcledokcdci&Channel=web_dl_btn";

export const SmallInGameAppDownloadButton = () => {
  const { t } = useTranslation();

  return (
    <div>
      <button
        onClick={() => {
          window.location.href = downloadLink;
        }}
        className="bg-white lg:space-x-2 shadow-lg flex items-center text-black font-bold rounded-xl py-2 px-4"
      >
        <img className="h-4 sm:h-5 md:h-6 lg:h-7" src={LiiferLogoSvg} alt="windows" />
        <span className="text-sm sm:text-sm md:text-base lg:text-base whitespace-nowrap px-2 pr-6">
          {t("liiferbucksmodal.downloadApp")}
        </span>
      </button>
    </div>
  );
};
